export const NavPills = Object.freeze({
  TYPE_CHILD: 'Child',
  TYPE_DEFAULT: 'Default',
  TYPE_SEPARATOR: 'Separator',
  TYPE_STATIC: 'Static',
});
